export default __webpack_public_path__ + "static/media/MedicinosBankas.15d42315.svg";